<template>
  <div 
    id="app" 
    v-if="$store.getters.getCountryList.length>0"
    style="height: 100vh; display: flex; flex-direction: column; justify-content: center; align-items: center;">
      <div :style="'width: '+($store.getters.getScreenWidth < 1400 ? '100%' : '90%')+'; max-width: 1920px; height: 97vh; display: flex; flex-direction: column; justify-content: space-between; align-items: center;'">
        <div style="width: 100%; display: flex; flex-direction: column;">
        <Header @toggleSignup="toggleSignup" />
        <router-view @toggleSignup="toggleSignup" style="top: 10px; position: relative;"/> 
        </div>        
        <Footer />

      </div>
      
      <el-dialog
          v-if="toggle_singup"
          :width="$store.getters.getScreenWidth>500 ? '400px' : '98%'"
          :visible.sync="toggle_singup"
          :close-on-click-modal="isFormSubmitted"
          :close-on-press-escape="isFormSubmitted"
          :show-close="isFormSubmitted"
          append-to-body>
              <SignUp @closed="toggle_singup = false"/>
      </el-dialog>

  </div>
  <div id="app" v-else style="width: 100%; text-align: center;">
    <h1>Loading...</h1>
  </div>
</template>

<script>
import Header from './components/Header/Index.vue'
import Footer from './components/Footer/Index.vue'
import SignUp from './views/SignUp/Index.vue'

export default {
  components: {Header, Footer, SignUp},
  data() {
    return {
      toggle_singup: false
    }
  },
  computed: {
      isFormSubmitted() {
        return this.$store.state.master.props.form_submitted
      }
  },
  methods: {
      toggleSignup() {
          console.log("here")
          this.toggle_singup = true
      },
      setDefaultProperties() {
          this.$store.dispatch('fetchVisitorGeography', this.$store.getters.getVisitorGeographyDetail)
      },
      handleWidthChange() {
        let screenWidth = window.screen.width
        this.$store.commit('setScreenWidth', screenWidth)

        if(document.getElementById("feature_list_port")) {
          this.$store.commit('setFeatureListPortWidth', document.getElementById("feature_list_port").clientWidth)
        }        
      }
  },
  mounted() {
      setTimeout(() => {
        this.$store.commit('setVisitorGeographyDetail', {country: localStorage.getItem('country'), timezone: localStorage.getItem('timezone')})
        this.setDefaultProperties()
        this.handleWidthChange();

        if(this.$route.query.signuprequest) {
             this.toggleSignup()
        }

      }, 300);
      window.scroll(0, 0) 
      
      window.addEventListener("resize", this.handleWidthChange);
  },
  updated() {
      this.handleWidthChange();
      this.$store.state.master.menu_toggle = false
  }
}


</script>


<style>
html, body {
  font-size: 13px;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: #383838;
  -moz-osx-font-smoothing: #383838;
  text-align: center;
  color: #383838;  
  margin: 0; 
  padding: 0; 
  overflow-x:hidden;
}

</style>



// WEBPACK FOOTER //
// src/App.vue